import { FunctionComponent, useEffect, useState } from 'react';
import cn from 'classnames';
import { useStore } from 'effector-react';
import { Spin, Pagination, Button } from 'antd';
import css from './PromotionActivityList.module.less';
import PromotionActivityPost from '../PromotionActivityPost/PromotionActivityPost';
import activity, { getList } from '@stores/activity';
import { pageSizeOptions } from '@constants/pagination';
import { SortAscendingOutlined, SortDescendingOutlined } from '@ant-design/icons';

const PromotionActivitList: FunctionComponent<unknown> = () => {
  const { list, pagination, preloaders, filters, setPagination } = useStore(activity);
  const [sortType, setSortType] = useState<string>('desc');
  const paginationChange = (current: number, pageSize?: number) => {
    setPagination({ ...pagination, current, pageSize });
    getList();
  };

  const changeSortFilter = () => {
    if (sortType === 'desc') {
      setSortType('asc');
    } else {
      setSortType('desc');
    }
  };

  useEffect(() => {
    getList();
  }, [filters, sortType]);

  return (
    <>
      <div className={cn(css.paginationContainer)}>
        <Pagination
          {...pagination}
          showSizeChanger
          showQuickJumper
          onChange={paginationChange}
          pageSizeOptions={pageSizeOptions}
        />
        <Button
          style={{ marginLeft: '10px' }}
          icon={sortType === 'desc' ? <SortDescendingOutlined /> : <SortAscendingOutlined />}
          onClick={changeSortFilter}
          shape='circle'
        />
      </div>

      <Spin spinning={!!preloaders.getList}>
        <div>
          {list.map((activity) => (
            <PromotionActivityPost
              key={activity.id}
              activity={activity}
            />
          ))}
        </div>
      </Spin>
      <div className={css.paginationContainer}>
        <Pagination
          {...pagination}
          showSizeChanger
          showQuickJumper
          onChange={paginationChange}
          pageSizeOptions={pageSizeOptions}
        />
      </div>
    </>
  );
};

export default PromotionActivitList;
